'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');
var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
require('./icons.scss');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/* eslint-disable */
var CyclingVirtualIcon = function (_PureComponent) {
  (0, _inherits3.default)(CyclingVirtualIcon, _PureComponent);
  function CyclingVirtualIcon() {
    (0, _classCallCheck3.default)(this, CyclingVirtualIcon);
    return (0, _possibleConstructorReturn3.default)(this, (CyclingVirtualIcon.__proto__ || (0, _getPrototypeOf2.default)(CyclingVirtualIcon)).apply(this, arguments));
  }
  (0, _createClass3.default)(CyclingVirtualIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        className = _props.className,
        otherProps = (0, _objectWithoutProperties3.default)(_props, ['className']);
      return _react2.default.createElement('svg', (0, _extends3.default)({
        viewBox: '0 0 32 32',
        style: {
          width: '1em',
          height: '1em'
        },
        preserveAspectRatio: 'xMidYMid meet'
      }, otherProps, {
        className: (0, _classnames2.default)('sb-icon-svg', className),
        xmlns: 'http://www.w3.org/2000/svg'
      }), _react2.default.createElement('path', {
        d: 'M31.15 10.833s-.21-.292-.46-.708-.624-1.917-.75-2.208a50.72 50.72 0 0 0-.666-1.375c-1.833-3.25-4.333-4.208-4.333-4.208l-4.207-1.292L19.816.5 19.4 0s-1.648 1.667-3.124 1.91L16.1 32h-.2l-.178-30.09C14.246 1.665 12.6 0 12.6 0l-.417.5-.917.542-4.208 1.292s-2.5.958-4.333 4.208c0 0-.542 1.083-.667 1.375s-.5 1.792-.75 2.208c-.25.417-.458.708-.458.708s-.542.875 1.833 1.875c1.14.48 1.742.605 2.06.605.346 0 .357-.146.357-.146s1.208-2.417 1.5-2.417c.292 0 .417.583.417.583s0 1.75.208 3.542c.208 1.792.875 3.958.875 4.75s.292 6.5.042 7.79c-.24 1.238-.213 1.912-.575 3.092a.23.23 0 0 0 .13.244c.663.296 3.196 1.25 8.176 1.25h.254c4.98 0 7.513-.955 8.176-1.25.12-.053.146-.19.13-.243-.362-1.18-.335-1.854-.575-3.09-.25-1.293.042-7 .042-7.792s.667-2.958.875-4.75c.208-1.792.208-3.542.208-3.542s.125-.583.417-.583 1.5 2.417 1.5 2.417.01.146.356.146c.318 0 .92-.125 2.06-.605 2.376-1 1.834-1.875 1.834-1.875z'
      }));
    }
  }]);
  return CyclingVirtualIcon;
}(_react.PureComponent);
CyclingVirtualIcon.propTypes = {
  className: _propTypes.PropTypes.string
};
exports.default = CyclingVirtualIcon;